import React from 'react';
import { useTheme } from '../context/ThemeContext';
import LeaderboardComponent from '../components/Leaderboard';

function Leaderboard() {
  const { isDark } = useTheme();

  return (
    <div className="max-w-6xl mx-auto mt-16 pb-0 flex-grow">
      <div className={`bg-white ${isDark ? 'dark:bg-hack-secondary/50' : 'bg-white'} rounded-lg shadow-xl overflow-hidden h-full`}>
        <div className="px-8 py-12">
          
         
          <LeaderboardComponent />
          <br></br>
          <br></br>  <br></br>
          <br></br>  <br></br>  <br></br>  <br></br>
          <br></br>
          <br></br>  <br></br>
          <br></br>  <br></br>  <br></br>  <br></br>
        </div>
      </div>
    </div>
    
  );
}

export default Leaderboard;
